import IncidentCriticalActionsAtAGlanceGraph from './IncidentCriticalActionsAtAGlanceGraph';

export default IncidentCriticalActionsAtAGlanceGraph;
